import { render, staticRenderFns } from "./SystemEvents.vue?vue&type=template&id=7ae21ff1&scoped=true"
import script from "./SystemEvents.vue?vue&type=script&lang=js"
export * from "./SystemEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae21ff1",
  null
  
)

export default component.exports